import { ActionReducerMap } from '@ngrx/store';
import { ColumnState } from './models/column-state.model';
import { columnStateReducer } from './reducers/column-state.reducer';
import { permissionReducer } from './reducers/permission.reducer';
import { tenantReducer } from './reducers/tenant.reducer';
import { PermissionState } from './models/permissions.model';
import { isCallCenterReducer } from './reducers/is-call-center.reducer';
import { TenantState } from './models/tenant.model';
import { TransactionTabState } from './models/transaction-tab.model';
import { transactionTabReducer } from './reducers/transaction-tab.reducer';

export interface AppState {
    columnState: ColumnState;
    isCallCenter: boolean;
    tenant: TenantState;
    permission: PermissionState;
    transactionTab: TransactionTabState;
}

export const appReducers: ActionReducerMap<AppState> = {
    columnState: columnStateReducer,
    isCallCenter: isCallCenterReducer,
    permission: permissionReducer,
    tenant: tenantReducer,
    transactionTab: transactionTabReducer,
};
